import { render, staticRenderFns } from "./ClassItem.vue?vue&type=template&id=f070fa62&scoped=true&"
import script from "./ClassItem.vue?vue&type=script&lang=js&"
export * from "./ClassItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassItem.vue?vue&type=style&index=0&id=f070fa62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f070fa62",
  null
  
)

export default component.exports